import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Client } from "urql";
import { getSignalGroupCategoriesBrandsQuery } from "../hooks/gqlHooks";

interface DataState {
  data: any[] | null;
  loading: boolean;
  initialized: boolean;
  fetchData: (urqlClient: Client) => Promise<void>;
  init: (urqlClient: Client) => void;
}

/**
 * Athenaからグループのカテゴリ・ブランド情報を取得・保存するストア
 * @note ブラウザタブクローズで初期化される
 */
export const useGroupCategoriesBrandsStore = create<DataState>()(
  persist(
    (set, get) => ({
      data: null,
      loading: false,
      initialized: false,
      fetchData: async (urqlClient: Client) => {
        if (get().data) return; // すでに取得済みなら再フェッチしない

        set({ loading: true });
        try {
          const { data, error } = await urqlClient.query(getSignalGroupCategoriesBrandsQuery, {}).toPromise();
          if (error) {
            console.error("fetching categories brands failed:", error);
            set({ loading: false });
            return;
          }
          set({ data: data.getAthenaSignalGroupCategoriesBrands, loading: false, initialized: true });
        } catch (e) {
          console.error("fetchData failed:", e);
          set({ loading: false });
        }
      },
      init: (urqlClient: Client) => {
        if (get().initialized) return;
        get().fetchData(urqlClient);
      },
    }),
    {
      name: "athena-signalgroup-categories-brands", // ストレージキー
      storage: createJSONStorage(() => sessionStorage), // sessionStorageを利用
    }
  )
);
